import { PostWorkstationPayload, Workstation } from "app/models/practice"

export enum Types {
  GET = "WORKSTATIONS_GET",
  GET_SUCCESS = "WORKSTATIONS_GET_SUCCESS",
  GET_FAIL = "WORKSTATIONS_GET_FAIL",
  PUT = "WORKSTATIONS_PUT",
  PUT_SUCCESS = "WORKSTATIONS_PUT_SUCCESS",
  PUT_FAIL = "WORKSTATIONS_PUT_FAIL",
  PATCH_ORDER = "WORKSTATIONS_PATCH_ORDER",
  PATCH_ORDER_SUCCESS = "WORKSTATIONS_PATCH_ORDER_SUCCESS",
  PATCH_ORDER_FAIL = "WORKSTATIONS_PATCH_ORDER_FAIL",
  POST = "WORKSTATIONS_POST",
  POST_SUCCESS = "WORKSTATIONS_POST_SUCCESS",
  POST_FAIL = "WORKSTATIONS_POST_FAIL",
}

export type Action =
  | GetWorkstationsAction
  | GetWorkstationsSuccessAction
  | GetWorkstationsFailAction
  | PutWorkstationsAction
  | PutWorkstationsSuccessAction
  | PutWorkstationsFailAction
  | PatchOrderWorkstationsAction
  | PatchOrderWorkstationsSuccessAction
  | PatchOrderWorkstationsFailAction
  | PostWorkstationsAction
  | PostWorkstationsSuccessAction
  | PostWorkstationsFailAction

export type GetWorkstationsAction = {
  type: Types.GET
}

export type GetWorkstationsSuccessAction = {
  payload: { data: Workstation[] }
  type: Types.GET_SUCCESS
}

export type GetWorkstationsFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PutWorkstationsAction = {
  payload: { data: Workstation }
  type: Types.PUT
}

export type PutWorkstationsSuccessAction = {
  type: Types.PUT_SUCCESS
}

export type PutWorkstationsFailAction = {
  payload: { errors: object }
  type: Types.PUT_FAIL
}

export type PatchOrderWorkstationsAction = {
  payload: { data: Workstation[] }
  type: Types.PATCH_ORDER
}

export type PatchOrderWorkstationsSuccessAction = {
  type: Types.PATCH_ORDER_SUCCESS
}

export type PatchOrderWorkstationsFailAction = {
  payload: { errors: object }
  type: Types.PATCH_ORDER_FAIL
}

export type PostWorkstationsAction = {
  payload: { data: PostWorkstationPayload }
  type: Types.POST
}

export type PostWorkstationsSuccessAction = {
  payload: { data: string }
  type: Types.POST_SUCCESS
}

export type PostWorkstationsFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export function getWorkstations(): GetWorkstationsAction {
  return {
    type: Types.GET,
  }
}

export function getWorkstationsSuccess(data: Workstation[]): GetWorkstationsSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getWorkstationsFail(errors: object): GetWorkstationsFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function putWorkstations(data: Workstation): PutWorkstationsAction {
  return {
    payload: { data },
    type: Types.PUT,
  }
}

export function putWorkstationsSuccess(): PutWorkstationsSuccessAction {
  return {
    type: Types.PUT_SUCCESS,
  }
}

export function putWorkstationsFail(errors: object): PutWorkstationsFailAction {
  return {
    payload: { errors },
    type: Types.PUT_FAIL,
  }
}

export function patchOrderWorkstations(data: Workstation[]): PatchOrderWorkstationsAction {
  return {
    payload: { data },
    type: Types.PATCH_ORDER,
  }
}

export function patchOrderWorkstationsSuccess(): PatchOrderWorkstationsSuccessAction {
  return {
    type: Types.PATCH_ORDER_SUCCESS,
  }
}

export function patchOrderWorkstationsFail(errors: object): PatchOrderWorkstationsFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_ORDER_FAIL,
  }
}

export function postWorkstations(data: PostWorkstationPayload): PostWorkstationsAction {
  return {
    payload: { data },
    type: Types.POST,
  }
}

export function postWorkstationsSuccess(data: string): PostWorkstationsSuccessAction {
  return {
    payload: { data },
    type: Types.POST_SUCCESS,
  }
}

export function postWorkstationsFail(errors: object): PostWorkstationsFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}
